module.exports = __webpack_public_path__ + "media/src/images/partners/ebs-534f6663b087dc7823a1087d3c928bdd.jpg";